export default class Ticker {
  constructor(data) {
    this.code = null;
    this.name = null;
    this.percentage = null;

    Object.assign(this, data);
  }
}
